


import {SystemDataType} from './SystemDataType'; 
export class SystemDataVM {
    
    id?: string;
    
    name?: string;
    
    dataType?: SystemDataType;
    
}
